module.exports = __webpack_public_path__ + "media/images/icons/rss-podcast-lg-4e6dcb10e690805c5f36efcdaf336bff.svg";